"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var SlidingTransition = _styledComponents.default.div.withConfig({
  displayName: "SlidingTransition",
  componentId: "sc-1aytbff-0"
})(["position:fixed;top:0;left:50%;width:50%;height:100%;z-index:2000;@keyframes slidein{from{margin-left:100%;}to{margin-left:0;}}@keyframes slideout{from{margin-left:0;}to{margin-left:100%;}}animation-duration:0.4s;animation-name:", ";@media (max-width:768px){left:30%;width:70%;}"], function (props) {
  return props.animation || "";
});

SlidingTransition.propTypes = {
  alignment: _propTypes.default.string
};
var _default = SlidingTransition;
exports.default = _default;